import { PlanningHubAndSpokeType } from '@recurrency/core-api-schema/dist/common/enums';
import { TenantSettingKey } from '@recurrency/core-api-schema/dist/common/tenantSettings';
import {
  FullReplenishmentPath,
  FullReplenishmentPathDTO,
} from '@recurrency/core-api-schema/dist/itemLocations/getItemLocations';

import { formatDateShorthand } from 'utils/formatting';
import { getTenantSetting } from 'utils/tenantSettings';

import { ItemReplenishmentPathNode } from '../../types';

// This whole thing really just renames a field and combines the upstream and downstream
// In the future if this needs to be modified, it should be done on the core-api side
export function buildTreeWithDownstream(
  node: FullReplenishmentPath,
  replenishmentPathData: FullReplenishmentPathDTO,
): ItemReplenishmentPathNode {
  if (!node.downstreamLocations?.length) {
    // This is the current location (last node), attach downstream tree here
    const children =
      replenishmentPathData?.downstreamTree?.map((dl) => ({
        key: dl.locationId,
        locationId: dl.locationId,
        locationName: dl.locationName,
        children: dl.downstreamLocations ? transformDownstreamToChildren(dl.downstreamLocations) : [],
      })) || [];

    return {
      key: node.locationId,
      locationId: node.locationId,
      locationName: node.locationName,
      children,
    };
  }

  // Continue traversing down the tree
  return {
    key: node.locationId,
    locationId: node.locationId,
    locationName: node.locationName,
    children: [buildTreeWithDownstream(node.downstreamLocations[0], replenishmentPathData)],
  };
}

// Helper function to recursively transform downstream locations into children
function transformDownstreamToChildren(downstreamLocations: FullReplenishmentPath[]): ItemReplenishmentPathNode[] {
  return downstreamLocations.map((location) => ({
    key: location.locationId,
    locationId: location.locationId,
    locationName: location.locationName,
    children: location.downstreamLocations ? transformDownstreamToChildren(location.downstreamLocations) : [],
  }));
}

export const useAggregatedNetstockEnabled = () => ({
  enabled: Boolean(
    getTenantSetting(TenantSettingKey.FeaturePurchasingNetstockAggregation) &&
      getTenantSetting(TenantSettingKey.FeaturePlanningHubAndSpoke) === PlanningHubAndSpokeType.Rigid,
  ),
});

export const formatLastPurchaseDate = (lastPurchaseDate: string | undefined | null) =>
  lastPurchaseDate ? formatDateShorthand(lastPurchaseDate) : 'Never';
